const sNettFontBlacklist = /[^\n-~\xa0-£¥-´¶-ÿ\u0152\u0153\u0178\u02c6\u02dc\u2000-\u200a\u2010-\u2014\u2018-\u201a\u201c-\u201e\u2022\u2026\u202f\u2039\u203a\u205f\u20ac\u2122\u25fc\ufb01\ufb02]/g;

export const useTextFilter = () => ({
    filterBySuperNett: (originalText: string) => originalText.replace(sNettFontBlacklist, ''),
});
